import { Axios, applyAuthHeader } from "../utils/axios";

export function get(url, params, config) {
  return Axios.get(
    url,
    applyAuthHeader({
      ...(config || {}),
      ...(params ? { params } : {})
    })
  );
}

export function post(url, data, config) {
  return Axios.post(url, data, applyAuthHeader(config || {}));
}

export function put(url, data, config) {
  return Axios.put(url, data, applyAuthHeader(config || {}));
}

export function del(url, config) {
  return Axios.delete(url, applyAuthHeader(config || {}));
}



// WEBPACK FOOTER //
// ./src/api/request.js